module.exports = ".child{\n  margin-left: 25px;\n}\n"